import type {ReactElement} from 'react';
import React from 'react';
import {Text, TextSize} from '@Components/text';
import {Icon} from '@Components/icon-v2';
import {IconShape, IconSize, IconType} from '@Components/icon-v2/icon.types';
import styles from './contextual-menu-text-header.module.scss';

interface ContextualMenuTextHeaderProps {
  text: string;
  icon?: string;
  className?: string;
  showBackButton?: boolean;

  onBackButton?(): void;
}

export function ContextualMenuTextHeader({
  className = '',
  icon = '',
  showBackButton = false,
  onBackButton = (): void => {},
  ...props
}: ContextualMenuTextHeaderProps): ReactElement<any> | null {
  return (
    <div className={`${styles.container} flex-center`}>
      {showBackButton ? (
        <Icon onClick={onBackButton} icon="icon-arrow-left" className={styles.icon} type={IconType.GHOST_UNCOLORED} size={IconSize.SIZE_ICON_20} shape={IconShape.SQUARE} />
      ) : null}
      {icon ? <Icon icon={icon} size={IconSize.SIZE_ICON_16} className={styles.marginRightIcon} /> : null}
      <Text val={props.text} size={TextSize.SMALL} bold className={className} />
    </div>
  );
}
